import styled from 'styled-components'

export const PriceFont = styled.p<{
    fontColor?: string
}>`
    font-weight: bold;
    font-size: 3rem;
    letter-spacing: .3rem;
    line-height: 1;
    color: ${({fontColor}) => fontColor ? fontColor : 'inherit'};
`

export const SpanFont = styled.p<{
    fontColor?: string,
    customPadding?: string
}>`
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: .1rem;
    align-self: center;
    padding: ${({customPadding}) => customPadding ? customPadding : 'inherit'};
    color: ${({fontColor}) => fontColor ? fontColor : 'inherit'};
`

export const TimeSpanFont = styled.p<{
    fontColor?: string,
    customPadding?: string
}>`
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: .1rem;
    align-self: center;
    padding: ${({customPadding}) => customPadding ? customPadding : 'inherit'};
    color: ${({fontColor}) => fontColor ? fontColor : 'inherit'};
`
